<template>
  <div class="video-player-container" v-show="visible">
    <div class="video-header">
      <span class="video-title">{{ title || '车辆实时监控' }}</span>

      <button @click="loadDetector" style="color: #fff;background-color: #000;border-radius: 4px;padding: 4px 8px;">检测视频</button>

      <close-outlined class="close-btn" @click="handleClose"/>
    </div>
    <div class="video-content">
      <video
          ref="videoRef"
          :src="videoUrl"
          controls
          autoplay
          loop
          muted
          class="video-element"
          @error="handleVideoError"
          @loadeddata="handleVideoLoaded"
      ></video>
    </div>

  </div>
</template>

<script>
import {defineComponent, ref, watch, onMounted} from 'vue';
import {CloseOutlined} from '@ant-design/icons-vue';

export default defineComponent({
  name: 'VideoPlayer',
  components: {
    CloseOutlined
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    videoUrl: {
      type: String,
      required: true
    }
  },
  emits: ['update:visible', 'close'],
  setup(props, {emit}) {
    const videoRef = ref(null);
    const showDetector = ref(false);
    const detectorUrl = ref('');
    // 监听可见性变化，如果隐藏则停止视频播放
    watch(() => props.visible, (newVal) => {
      console.log('视频播放器可见性变化:', newVal);
      if (!newVal && videoRef.value) {
        videoRef.value.pause();
      }
    });
    
    // 在组件挂载时添加调试信息
    onMounted(() => {
      console.log('视频播放器组件已挂载，初始可见性:', props.visible);
    });
    const loadDetector = () => {
      const videoUrl = 'https://shgis.oss-cn-hangzhou.aliyuncs.com/video/yolo.mp4';
      const encodedUrl = encodeURIComponent(videoUrl);
      window.open(`/yolo-detection/index.html?video=${encodedUrl}`, '_blank');
    };
    // 关闭视频播放器
    const handleClose = () => {
      if (videoRef.value) {
        videoRef.value.pause();
      }
      emit('update:visible', false);
      emit('close');
    };

    // 处理视频加载错误
    const handleVideoError = () => {
      console.error('视频加载失败');
    };

    // 处理视频加载完成事件
    const handleVideoLoaded = () => {
      // 可以在这里添加处理视频加载完成的逻辑
    };

    return {
      videoRef,
      showDetector,
      detectorUrl,
      loadDetector,
      handleClose,
      handleVideoError,
      handleVideoLoaded
    };
  }
});
</script>

<style scoped>
.video-player-container {
  width: 600px;
  max-width: 80vw;
  max-height: 50vh; /* 限制高度为视口高度的50% */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #000;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #1e1e1e;
  color: #fff;
  flex-shrink: 0; /* 防止头部被压缩 */
}

.video-title {
  font-size: 14px;
  font-weight: 500;
}

.close-btn {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  padding: 4px;
}

.close-btn:hover {
  color: #ff4d4f;
}

.video-content {
  width: 100%;
  height: 100%;
  overflow: hidden; /* 防止内容溢出 */
  flex: 1; /* 填充剩余空间 */
}

.video-element {
  width: 100%;
  height: auto; /* 自动高度以保持比例 */
  max-height: calc(50vh - 40px); /* 减去header高度 */
  display: block;
  object-fit: contain; /* 保持视频比例 */
}
</style> 